<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container grid-list-xl pt-0>
            <page-tool-bar
                show_search
                show_building
                :chosen_building.sync="chosen_building"
                :search.sync="search"
            >
                <v-flex shrink>
                    <div class="text-right">
                        <create-internet @reloadTable="reload_table++"></create-internet>
                        <v-btn @click="exportCSV++" color="primary" dark>XUẤT EXCEL</v-btn>
                    </div>
                </v-flex>
            </page-tool-bar>
            <v-layout row wrap justify-center>
                <v-flex xs12>
                    <v-card>
                        <internet-table :exportCSV="exportCSV" :chosen_building="chosen_building" :search="search" :reload_table="reload_table"></internet-table>
                    </v-card>
                </v-flex>
            </v-layout>
		</v-container>
	</div>
</template>
<script>
import api from "../../api";
import moment from 'moment'
import { buildParamQuery, formatTimeServer, dayDiff } from '../../helpers/helpers.js'
import CreateInternet from './CreateInternet'
import InternetTable from './InternetTable'

export default {
    name: 'quan-ly-internet',
    components: {
        CreateInternet,
        InternetTable
    },
    data() {
        return {
            search:'',
            reload_table: 0,
            chosen_building: '',
            exportCSV: 0
        };
	},
    mounted(){
        this.reload_table++
    },
};
</script>
